/* eslint-disable react/no-array-index-key */
import styled from '@emotion/styled';

const BreakOnNewLine = styled('div')`
  white-space: pre-wrap;
`;

BreakOnNewLine.displayName = 'BreakOnNewLine';

export default BreakOnNewLine;
